module.exports = __webpack_public_path__ + "media/components/trial/common/statics/pengin-41797d33e7b886e103be22957f78c6a1.png";